import { Component } from '@angular/core';
import {
  FooterComponent,
  NavItemComponent,
  NavLinkDirective,
  NavModule,
} from '@coreui/angular-pro';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
  imports: [NavItemComponent, NavLinkDirective, NavModule, RouterLink],
  standalone: true,
})
export class DefaultFooterComponent extends FooterComponent {
  constructor() {
    super();
  }
}
